// 法律声明
<template>
  <div>
    <logo></logo>
    <!-- <Header /> -->
    <div class="context">
      <div class="container-fluid">
        <h3 class="h3_title">法律声明</h3>
        <div class="row law_detail">
          <div class="col-sm-8 col-sm-offset-2">
            <p class="i18n-bd">
              感谢您对北京清大天达光电科技股份有限公司（以下简称“清大天达”）的关注，希望您在访问本网站时，对如下内容先行认真阅读，使用本网站即表明您已经知晓并接受以下条款。清大天达保留随时自行决定更改、修改、更新本网站及本声明的权利，恕不另行通知。
            </p>
            <p class="i18n-bd">
              本网站为清大天达唯一合法官方网站，由清大天达拥有、管理和维护。对于您能看到的内容，我们希望您仅用于浏览目的，不用于其他非经清大天达正式书面授权的用途。
            </p>
            <h4 class="i18n-bd">免责声明</h4>
            <p class="i18n-bd">
              本网站所载的内容包括但不限于文字、图片、数据、建议、链接等，仅供访问者参考，虽然清大天达力图在网站上提供准确的材料和信息，但清大天达不能保证这些信息内容的完整性、准确性、可靠性、合法性，且明确声明不对这些信息的遗漏或错误承担法律责任，也不对这些内容作出任何明示或默示的保证，包括但不限于所有权、知识产权及网络安全等。
            </p>
            <h4 class="i18n-bd">其他网站的链接</h4>
            <p class="i18n-bd">
              清大天达对您通过本网站的链接而进入其他网站不承担任何责任。当您进入其他网站时，您已充分理解这些网站与清大天达是无关的，并且也不在清大天达的控制范围内。另外，清大天达对本网站链接的其他网站本身并不表示认可或承担其他网站内容或使用上的责任。您应谨慎地进入其他网站，以免遭病毒或其他破坏性程序的侵害。
            </p>
            <h4 class="i18n-bd">版权声明</h4>
            <p class="i18n-bd">
              清大天达的名称、商标、标识、图片、视频、音频、文字等，均受有关著作权、商标权及其他知识产权相关法律以及国际公约中有关著作权、商标权及其他权利法律的保护，为清大天达或相关权利人专属所有或持有。除《中华人民共和国著作权法》（2020年11月修正版）第二十四条规定的合理使用情形外，未经清大天达或其他权利持有人的书面同意，任何人不得私自将本网站的任何内容以任何方式进行使用与传播，包括但不限于复制、转载、修改、经销等方式。
            </p>
            <h4 class="i18n-bd">商标权声明</h4>
            <p class="i18n-bd">
              本公司对于“清大天达”等文字或形象均进行了商标注册保护，未经清大天达公司书面许可，任何人不得擅自使用。对于涉嫌侵犯本公司注册商标权的行为，清大天达保留追究法律责任的权利。
            </p>
            <h4 class="i18n-bd">法律适用和管辖</h4>
            <p class="i18n-bd">
              本网站及网站声明，适用中华人民共和国法律。任何有关本网站和网站声明的争议，应由清大天达住所地有管辖权的人民法院管辖。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import api from '@/utils/api'
export default {
  name: 'Legal',
  components: {
    // Header,
    Logo,
  },
  methods: {},
}
</script>
<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
/deep/ .context {
  width: 43.875rem;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10rem;
  font-size: 1.834rem;
  line-height: 3rem;
  margin-bottom: 6rem;
}
h4{
  margin-top:2rem;
}
p{
  margin-top:2rem;
  text-indent: 3rem;
  text-align: justify; /*实现两端对齐*/
  text-justify: newspaper; /*通过增加或减少字或字母之间的空格对齐文本*/
  word-break: break-all; /*允许在单词内换行*/
}
.h3_title{
  text-align: center;
}
.tabbar {
  margin-top: 24.125rem;
}
</style>
